import { Button, Col, HorizontalRule, Modal, Row } from '@snsw/react-component-library';
import React, { Fragment, useRef, useState } from 'react';
import FieldError from '../fieldError';
import style from './ListView.module.scss';

export const ListView = (props) => {
  const {
    title = '',
    helpMessage = '',
    items = [],
    buttonAddTitle = 'Add',
    onAdd = () => {},
    onEdit = (index, item) => {},
    onRemove = (index, item) => {},
    renderRowTitle = (index, item) => {},
    renderRowDetails = (index, item) => {},
    maxItemLimit = -1,
    errorMessage = '',
    hasError = false,
    confirmationTitle = 'Are you sure you want to remove this?',
    confirmationDescription = 'This cannot be undone.',
    showEditRemove = true,
    showAddButton = true,
    confirmRemoveTitle = 'Remove',
    cancelRemoveTitle = 'Cancel',
  } = props;

  const indexRef = useRef();

  const [showModal, setShowModal] = useState(false);

  const onClickRemoveRow = (index) => {
    indexRef.current = index;
    setShowModal(true);
  };

  const onClickEditRow = (index) => {
    let item = items[index];
    onEdit(index, item);
  };

  const onConfirmRemove = () => {
    setShowModal(false);
    let item = items[indexRef.current];
    onRemove(indexRef.current, item);
  };

  const cancelFunction = () => {
    setShowModal(false);
  };

  const rows = items.map((item, index) => (
    <Fragment key={index}>
      <Row alignItems="start">
        <Col span={9}>
          {renderRowTitle(index, item)}
          {renderRowDetails(index, item)}
        </Col>
        {showEditRemove && (
          <Col span={3} className={style.editRemove}>
            <Button
              variant="link"
              onClick={() => {
                onClickEditRow(index);
              }}
            >
              Edit
            </Button>
            &nbsp;|&nbsp;
            <Button
              variant="link"
              onClick={() => {
                onClickRemoveRow(index);
              }}
            >
              Remove
            </Button>
          </Col>
        )}
      </Row>
      <Row>
        <Col span={12}>
          <HorizontalRule className={style.horizontalRule} />
        </Col>
      </Row>
    </Fragment>
  ));

  return (
    <>
      <Row>
        <Col span={12}>
          <div className={style.labelMsg}>{title}</div>
          {helpMessage && <div className={style.helpMsg}>{helpMessage}</div>}
          {items && items.length > 0 && <HorizontalRule className={style.horizontalRule} />}
        </Col>
      </Row>
      {rows}
      {/* hide 'add button' if reach maxlimit */}
      {(maxItemLimit > 0 && items.length >= maxItemLimit) || !showAddButton ? null : (
        <div className={style.addButton}>
          <Button
            variant="secondary"
            onClick={(e) => {
              onAdd();
            }}
          >
            {buttonAddTitle}
          </Button>
        </div>
      )}
      {hasError && <FieldError message={errorMessage} />}

      {showModal && (
        <Modal
          title={confirmationTitle}
          description={confirmationDescription}
          buttons={[
            { text: confirmRemoveTitle, onClick: onConfirmRemove },
            { text: cancelRemoveTitle, onClick: cancelFunction },
          ]}
        />
      )}
    </>
  );
};
